export default __webpack_public_path__ + "static/media/trading.1b1188c5.webp";